import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { photoUrl } from "@/lib/api";
import { slotLabel } from "@/lib/options";

export const PhotoGallery = ({ photos }) => {
  const [idx, setIdx] = useState(null);
  if (!photos.length) return <p className="text-sm text-slate-600" data-testid="no-photos">No photos were attached.</p>;
  const cur = idx != null ? photos[idx] : null;
  const step = (d) => setIdx((i) => (i + d + photos.length) % photos.length);
  return (
    <>
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-4" data-testid="photo-gallery">
        {photos.map((p, i) => (
          <button key={p.id} type="button" onClick={() => setIdx(i)} className="group relative aspect-[4/3] overflow-hidden rounded-md border border-border bg-slate-100" data-testid={`gallery-photo-${i}`}>
            <img src={photoUrl(p.id, "thumb")} alt={slotLabel(p.slot)} loading="lazy" className="h-full w-full object-cover" />
            <span className="absolute inset-x-0 bottom-0 bg-black/60 px-2 py-1 text-left text-xs font-medium text-white">{slotLabel(p.slot)}</span>
          </button>
        ))}
      </div>
      <Dialog open={cur != null} onOpenChange={(o) => !o && setIdx(null)}>
        <DialogContent className="max-w-5xl p-2 sm:p-4" data-testid="photo-viewer">
          <DialogTitle className="text-sm">{cur && `${slotLabel(cur.slot)} · ${idx + 1} of ${photos.length}`}</DialogTitle>
          {cur && <img src={photoUrl(cur.id, "full")} alt={slotLabel(cur.slot)} className="max-h-[75vh] w-full object-contain" data-testid="photo-viewer-image" />}
          <div className="flex justify-between">
            <button type="button" onClick={() => step(-1)} className="inline-flex items-center rounded border px-3 py-2 text-sm" data-testid="photo-prev"><ChevronLeft className="h-4 w-4" />Previous</button>
            {cur && <a href={photoUrl(cur.id, "full")} target="_blank" rel="noreferrer" className="link self-center text-sm">Open full size</a>}
            <button type="button" onClick={() => step(1)} className="inline-flex items-center rounded border px-3 py-2 text-sm" data-testid="photo-next">Next<ChevronRight className="h-4 w-4" /></button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
